import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
import * as types from './types';

export const bookingPromotersMutations = {
  [types.SET_BOOKING_PROMOTERS](state, payload) {
    state.bookingPromoters = payload;
  },
  [types.SET_MORE_BOOKING_PROMOTERS](state, payload) {
    state.bookingPromoters = state.bookingPromoters.concat(payload);
  },
  [types.SET_CLIENT_DISPLAY_NAME](state, payload) {
    state.clientDisplayName = payload;
  },
  [types.SET_CONTACTS_FOR_PROMOTER](state, payload) {
    state.contactsForPromoter = payload;
  },
  [types.SET_MORE_CONTACTS_FOR_PROMOTER](state, payload) {
    state.contactsForPromoter = state.contactsForPromoter.concat(payload);
  },
  [types.SET_BOOKING_PROMOTER_SELECTED](state, payload) {
    state.bookingPromoterSelected = payload;
  },
  [types.SET_BOOKING_PROMOTER_SELECTED_TAB](state, payload) {
    state.bookingPromoterSideWindowSelectedTab = payload;
  },
  [types.SET_BOOKING_PROMOTER_TAB_OVERVIEW](state, payload) {
    state.bookingPromoterSelectedOverView = payload;
  },
  [types.SET_BOOKING_PROMOTER_TAB_BOOKINGS](state, payload) {
    state.bookingPromoterSelectedBookings = payload;
  },
  [types.SET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO](state, payload) {
    state.bookingPromoterSelectedAdditionalInfo = payload;
  },
  [types.SET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO_FILES](state, payload) {
    state.bookingPromoterSelectedAdditionalInfo.files = payload;
  },
  [types.SET_ROUTE_QUERY_MODAL](state, payload) {
    state.routeQueryModal = payload;
  },
  [types.SET_IS_SELECTED_PROMOTER_LOADING](state, isLoading) {
    state.isSelectedPromoterLoading = isLoading;
  },
  ...implementSetAllNavTabDetailsMutation(types.PromoterDetails, 'promoterDetails'),
}